<template>
  <div class="card-actions action-deal-archive">
    <div class="action-deal-signed__intro">
      {{ trans('deal_dashboard.action.archive.intro') }}
    </div>
    <div
      ref="actionContent"
      class="card-actions__content action-deal-content"
    >
      <div class="action-deal-content__choice action-deal-content__fieldset">
        <button class="btn btn--unsigned" @click="onUnsignedClick">
          {{ trans('deal_dashboard.action.archive.unsigned') }}
        </button>
        <button class="btn btn--signed" @click="onSignedClick">
          {{ trans('deal_dashboard.action.archive.signed') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash-es';
import { flashBagError, flashBagSuccess } from '@tools/flashbag';
import { URL_XHR_BUYER_DASHBOARD_DEAL_ARCHIVE } from '@tools/routes/routes';
import { Logger } from '@tools/logger/logger';
import { requestsMixin } from '@tools/requests-mixin';
import { COLUMN__SIGNED, COLUMN__UNSIGNED } from '@organisms/deal-dashboard/constants';
import { CardActionPayload } from '@organisms/deal-dashboard/card/CardActionPayload';
import { actionsMixins } from './actions-mixins';
import { ACTIONS, EVENTS } from './constants';

export default {
  mixins: [ actionsMixins, requestsMixin ],
  props: {
    action: { type: String, required: true },
    payload: { type: CardActionPayload, required: true },
  },
  data() {
    return {
      title: this.trans('deal_dashboard.action.archive.title'),
    };
  },
  mounted() {
    if (this.action === ACTIONS.DEAL__ARCHIVE_UI) {
      this.$emit(EVENTS.TITLE_UPDATE, this.title);
      return;
    }

    this.performArchive();
  },
  methods: {
    onCancelClick() {
      this.$emit(EVENTS.ACTION_CANCELLED);
    },
    onSignedClick() {
      this.$emit(EVENTS.ACTION_PERFORMED, this.createNextPayloads(ACTIONS.DEAL__SIGNED, COLUMN__SIGNED));
    },
    onUnsignedClick() {
      this.$emit(EVENTS.ACTION_PERFORMED, this.createNextPayloads(ACTIONS.DEAL__UNSIGNED, COLUMN__UNSIGNED));
    },
    /**
     * @param {String} nextAction
     * @param {String} toColumn
     * @return {CardActionPayload}
     */
    createNextPayloads(nextAction, toColumn) {
      // Clone the current payload and change it to build the next step (current payload + 1)
      /** @type {CardActionPayload} payload */
      const next1 = cloneDeep(this.payload);
      next1.action = nextAction;
      next1.toColumn = toColumn; // Simulate a card move to this column
      // Create a new payload to queue (current payload + 2)
      const next2 = new CardActionPayload();
      next2.action = ACTIONS.DEAL__ARCHIVE;
      next2.deal = next1.deal;
      next1.next = next2;
      return next1;
    },
    async performArchive() {
      let response = null;
      try {
        response = await this.post(
          URL_XHR_BUYER_DASHBOARD_DEAL_ARCHIVE.replace('{id}', this.deal.id),
          {},
        );
      } catch (error) {
        Logger.error(error);
      }

      if (response && response.status === 204) {
        flashBagSuccess(this.trans('deal_dashboard.action.archive.success'));
        this.$emit(EVENTS.ACTION_PERFORMED);
        return;
      }
      flashBagError(this.trans('deal_dashboard.action.archive.failure'));
      this.$emit(EVENTS.ACTION_PERFORMED);
    },
  },
};
</script>
